module.exports = __webpack_public_path__ + "img/BTN.44769871.svg";